import React from "react"
import { Link } from "react-router-dom"

const Support = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <Link to="/" className="text-indigo-600 hover:text-indigo-500">
            &larr; Back to Home
          </Link>
        </div>

        <div className="bg-white shadow rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Support</h1>

          <div className="prose prose-indigo max-w-none text-gray-700">
            <p className="text-lg">
              Have questions or suggestions? We'd love to hear from you.
            </p>
            <p className="mt-4">
              Contact us at{" "}
              <a
                href="mailto:help@heartily.app"
                className="text-indigo-600 hover:text-indigo-500 font-medium"
              >
                help@heartily.app
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Support
